import React from "react";
import { View } from "react-native";

function ProfileItemDivider() {
  return <View className="h-[1px] bg-gray-100" />;
}

export default ProfileItemDivider;